import { Box, Grid, IconButton, ListItemIcon, ListItemText, makeStyles, Menu, MenuItem, Typography, TextField } from '@material-ui/core';
import { Button, ConfirmDialog, DataGrid, GridColumnProps, LinkColumn, StandardDialog, Toolbar } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { formatDate } from '@roc/feature-utils';
import { formatCurrency, noOpComparator } from '@roc/ui/utils';
import { ToolbarInfoItem } from '@roc/feature-special-servicing';
//import { PayableReceivablesTypes } from '../../types/types';
import { Alert } from "@material-ui/lab";
import { useTaxCertificateStore } from '../hooks/useTaxCertificateStore';
import { getPaymentApprovalColumns } from '../utils/constants';
import { PaymentApprovalFilter } from '../types/types';
import { StatusEditorPaymentApprobal } from './statusEditorPaymentApprobal';

const useStyles = makeStyles(theme => ({
  gridContainer: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    height: '55vh',
    overflow: 'hidden',
  },
  containerBox: {
    display: 'flex',
  },
  infoItemsBox: {
    marginRight: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '30px'
  },
}));

export const PaymentApprovalModal = observer(() => {
  const { taxCertificateStore,
    taxCertificateStore: {
      detailsModalOpen,
      selectedRecord,
      taxCertificateGridStore,
      taxPaymentDetailsGridStore,
    }
  } = useTaxCertificateStore()
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const sendPaymentApproval = async () => {
    await taxCertificateStore.sendTaxIdsPaymentApproval();
    taxPaymentDetailsGridStore.resetAndFetchGridData();
    setOpenConfirmModal(false);
  }

  const getContent = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PaymentApprovalGrid />
        </Grid>
      </Grid>
    );
  }

  const handleCLoseModal = () => {
    taxCertificateStore.closeModal();
    taxCertificateGridStore.resetAndFetchGridData();
  }

  return (
    <>
      <StandardDialog
        open={detailsModalOpen}
        title={`Tape ${selectedRecord?.tape}`}
        maxWidth="lg"
        handleClose={handleCLoseModal}
        dialogContent={getContent}
        dialogActions={(
          <>
            <Button
              onClick={() => setOpenConfirmModal(true)}
              color="primary"
              variant="contained"
              testId="approve"
              disabled={taxPaymentDetailsGridStore.gridData.data.rows < 1}
            >
              Send Payment Approval
            </Button>
          </>
        )}
      />
      <ConfirmDialog
        open={openConfirmModal}
        body={<span>Are you sure you want to send the payment approval request?</span>}
        confirmButtonText={'Confirm'}
        handleCancel={() => setOpenConfirmModal(false)}
        handleClose={() => setOpenConfirmModal(false)}
        handleConfirm={sendPaymentApproval}
      />
    </>

  );

});


const PaymentApprovalGrid = observer(() => {
  const classes = useStyles();
  const { taxCertificateStore,
    taxCertificateStore: {
      selectedRecord,
      taxPaymentDetailsGridStore,
      totalDetailsAmount
    }
  } = useTaxCertificateStore()

  useEffect(() => {
    taxPaymentDetailsGridStore.resetAndFetchGridData();
  }, [selectedRecord]);

  const frameworkComponents = {
    dateCellRenderer: ({ value }) => {
      return value ? formatDate(value, 'MM/dd/yyyy') : '';
    },
    currencyCellRenderer({ value }) {
      return formatCurrency(value);
    },
    dropdownGridEditor: StatusEditorPaymentApprobal,
  };


  const onSortChanged = params => {
    const sortModel = params.api.getSortModel();
    taxPaymentDetailsGridStore.setSortModel(sortModel);
  };

  const onFilterChanged = params => {
    const filterModel = params.api.getFilterModel();
    taxPaymentDetailsGridStore.setFilterModel(filterModel);
  };

  return (

    <Box>
      <Grid item className={classes.gridContainer}>
        <DataGrid
          columns={getPaymentApprovalColumns(PaymentApprovalFilter.TAPE)}
          rows={taxPaymentDetailsGridStore.gridData.data.rows}
          frameworkComponents={frameworkComponents}
          suppressRowClickSelection={true}
          toolbar={<PaymentApprovalToolbar totalDetailsAmount={totalDetailsAmount} />}
          key={selectedRecord?.id}
          onSortChanged={onSortChanged}
          onFilterChanged={onFilterChanged}
          isLoading={taxPaymentDetailsGridStore.isLoading}
          showFilters={taxPaymentDetailsGridStore.showFilters}
          sortModel={taxPaymentDetailsGridStore.sortModel}
          filterModel={taxPaymentDetailsGridStore.filterModel}
          paginationData={taxPaymentDetailsGridStore.gridData.meta}
          setPageNumber={taxPaymentDetailsGridStore.setPageNumber}
        />
      </Grid>
    </Box>
  );

});

const PaymentApprovalToolbar = observer(({ totalDetailsAmount }) => {
  const classes = useStyles();

  return (
    <Grid container>
      <Grid item xs={12}>
        <Toolbar left={
          <Typography variant='h6'>Bills </Typography>
        }>
          <Box className={classes.containerBox} >
            <Box className={classes.infoItemsBox}>
              <ToolbarInfoItem value={`${'$'}${totalDetailsAmount}`} label={"Total Amount"} />
            </Box>
          </Box>
        </Toolbar>
      </Grid>
    </Grid>
  );
});
